import { IAssignment } from "./assignment";
import { IAttachment } from "./attachment";
import { ILocation, LocationCreator } from "./location";
import { IParkingBanException } from "./parking-ban-exception";
import { IServiceModelBase } from "./servicemodelbase";
import { ISignScan } from "./sign-scan";

export interface IParkingBan extends IServiceModelBase {
    name: string;
    description: string;
    isCompleted: boolean;
    start?: Date;
    end?: Date;

    assignment?: IAssignment;
    exceptions?: IParkingBanException[];
    location?: ILocation;
    photos?: IAttachment[];
    signScans?: ISignScan[];
}

export class ParkingBanCreator {
    name: string;
    description: string;
    isCompleted: boolean;
    start?: Date;
    end?: Date;

    assignmentId?: number;
    locationId?: number;
    location?: LocationCreator;
}

export class ParkingBanUpdater extends ParkingBanCreator {
    id: number;

    init(parkingBan: IParkingBan): ParkingBanUpdater {
        this.start = parkingBan?.start;
        this.end = parkingBan?.end;
        this.id = parkingBan.id;
        this.name = parkingBan.name;
        this.description = parkingBan.description;
        this.isCompleted = parkingBan.isCompleted;
        this.assignmentId = parkingBan.assignment ? parkingBan.assignment.id : undefined;
        this.locationId = parkingBan.location ? parkingBan.location.id : undefined;

        return this;
    }
}
